<template>
	<div id="logout" class="pos-fix z-index-1">
        <div class="pos-rel dp-fx fx-js-ct wd-full ht-full">
            <div class="mg-t-60">
                <div class="text-center">
                    <router-link to="/">
                        <img height="40" src="../assets/logo.png" alt="Nepometer Logo"/>
                    </router-link>
                </div>
                <hr class="wd-px-300 mg-t-46"/>
                <div class="dp-fx fx-dr-col fx-al-ct">
                    <div v-if="currentUser">
                        <img v-if="currentUser.photoURL" :src="currentUser.photoURL" :alt="currentUser.displayName" class="user-img-lg">
                        <img v-else src="https://o.cdn.newsbytesapp.com/assets/people/na.2.jpg" :alt="currentUser.displayName" class="user-img-lg">
                        <p class="mg-t-40 cl-blue fz-14 lh-20 pd-t-10 pd-b-10 pd-l-10 pd-r-10 cs-ptr" @click="logout">Logout</p>
                    </div>
                    <div v-else>
                        <p class="mg-t-40 cl-blue fz-14 lh-20 pd-t-10 pd-b-10 pd-l-10 pd-r-10 cs-ptr">You are already logged out</p>
                    </div>
                </div>
            </div>
        </div>
	</div>
</template>

<style>
    .user-img-lg {
        width: 100px;
        height: 100px;
        border-radius: 50%;
    }
</style>

<script>
	import 	{ mapState } from "vuex"
	const fb = require('../firebaseConfig.js');

	export default {
		name: "Logout",
		methods: {
			logout() {
				fb.auth().signOut().then(() => {
                    console.log('User logged out');
				}).catch(err => {
					console.log(err)
				})
                this.$store.dispatch('clearData');
                this.$store.dispatch('deactivateCommentsModal');
                this.$router.go(-1);
			}
		},
		computed: {
			...mapState(['currentUser'])
		}
	}
</script>